import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";
import { LoanOptionBlockCombo } from "./comparison_views/molecules/LoanOptionBlockCombo";

class IrqLoanOptionsView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <LoanOptionBlockCombo {...this.props} />
          <EditActions
            canSubmit={this.props.isValid}
            onSubmit={this.props.onSubmit}
            navigationsAway={this.props.navigationsAway}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqLoanOptionsView));
